const c = {
    media_chan: {
        direct_mail: 1,
        print: 2,
        email: 3,
        online_display: 5,
        social_media: 6,
        search_engine_marketing: 9,
        online_video: 10,
        dashboard_only: 13,
        website_url: 14,
    },
    communication_type: {
        business_content_incentive: 1,

    },
    sector: {
        banking: 87,
        credit_card: 90,
        mortgage_loan: 6,
        retail: 266,
        telecomm: 9,
        travel_leisure: 219,
        energy: 315,
        automotive: 372,
        insaurance: 4,
        investment: 5,
        non_profit: 560,
        consumer_service:559,
    },
    category: {
        credit_access_offer: 179,
        payment_card: 178,
    },
    audience: {
        consumer: 1,
        employee_business_owner: 2,
    }
}

export default c